import { Typography } from '@mui/material';
import { FC } from 'react';

interface SubTitleTextProps {
    text: string;
}

export const SubTitleText: FC<SubTitleTextProps> = ({ text }) => {
    return (
        <Typography variant="h3" className="text-lg font-semibold">
            {text}
        </Typography>
    );
};
